var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 4.5,
    stroke: "#009AD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9677 58.1897H38.0356V68.5037H47.979C48.7047 68.5037 49.2925 68.1404 49.2925 67.6931V58.9947C49.2869 58.5475 48.6934 58.1897 47.9677 58.1897Z",
    fill: "#009AD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.938 58.9947V67.6931C31.938 67.9081 32.0246 68.1143 32.1789 68.2663C32.3331 68.4183 32.5423 68.5037 32.7604 68.5037H38.9736V58.1897H32.7604C32.5432 58.1897 32.3349 58.2743 32.1809 58.4251C32.0268 58.5759 31.9395 58.7807 31.938 58.9947Z",
    fill: "#009AD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53.8539V56.432C31 56.8858 31.5295 57.2517 32.182 57.2517H42.726V53.0314H32.182C31.5295 53.0314 31 53.4001 31 53.8539Z",
    fill: "#009AD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4312 53.0314H42.2568L42.2734 57.2517H49.4312C49.6432 57.2517 49.8465 57.1654 49.9964 57.0116C50.1463 56.8579 50.2305 56.6494 50.2305 56.432V53.8539C50.2309 53.746 50.2105 53.6391 50.1705 53.5393C50.1305 53.4396 50.0717 53.3489 49.9974 53.2725C49.9231 53.196 49.8349 53.1354 49.7377 53.094C49.6406 53.0527 49.5364 53.0314 49.4312 53.0314Z",
    fill: "#009AD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 31.6458C39.3671 31.6458 38.2808 31.1958 37.4799 30.3949C36.679 29.594 36.229 28.5077 36.229 27.375C36.229 26.2423 36.679 25.156 37.4799 24.355C38.2808 23.5541 39.3671 23.1041 40.4998 23.1041C41.6325 23.1041 42.7188 23.5541 43.5198 24.355C44.3207 25.156 44.7707 26.2423 44.7707 27.375C44.7707 27.9358 44.6602 28.4912 44.4456 29.0093C44.2309 29.5275 43.9164 29.9983 43.5198 30.3949C43.1232 30.7915 42.6524 31.1061 42.1342 31.3207C41.6161 31.5353 41.0607 31.6458 40.4998 31.6458ZM40.4998 15.4166C37.3283 15.4166 34.2866 16.6765 32.044 18.9191C29.8014 21.1618 28.5415 24.2034 28.5415 27.375C28.5415 36.3437 40.4998 49.5833 40.4998 49.5833C40.4998 49.5833 52.4582 36.3437 52.4582 27.375C52.4582 24.2034 51.1983 21.1618 48.9557 18.9191C46.713 16.6765 43.6714 15.4166 40.4998 15.4166Z",
    fill: "#009AD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLocation);
export default __webpack_public_path__ + "static/media/product-location.00176b06.svg";
export { ForwardRef as ReactComponent };